import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class VoiceFlowService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private storage: Storage
  ) {
    this.url = environment.server;
  }

  public initVoiceFlowCustom = async (simulation: string, attemptId: string, key: string, apiKey: string) => {
    const user = await this.storage.get('user');
    const url = `${this.url}/voiceflow/start`;
    const body = {
      user: attemptId,
      apiKey,
      actions: [
        simulation,
        user.displayName,
        key
      ],
    };
    return lastValueFrom(this.http.post(url, body, { responseType: 'text' }));
  };

  public initVoiceFlow = async (
    group: string,
    simulation: string,
    level: string,
    attemptId: string,
    apiKey: string
  ): Promise<string> => {
    const user = await this.storage.get('user');
    const url = `${this.url}/voiceflow/start`;
    const body = {
      user: attemptId,
      apiKey,
      actions: [
        group,
        simulation,
        level,
        user.firstName
      ]
    };
    return lastValueFrom(this.http.post(url, body, { responseType: 'text' }));
  };

  public initVoiceFlowWithParameters = async (parameters: any, apiKey: string, attemptId: string): Promise<string> => {
    const url = `${this.url}/voiceflow/start`;
    const body = {
      user: attemptId,
      apiKey,
      actions: [],
      params: parameters
    };
    return lastValueFrom(this.http.post(url, body, { responseType: 'text' }));
  };

  public interactVoiceFlow = (payload: string, attemptId: string, apiKey: string, responseType = 'text'): Observable<any> => {
    const url = `${this.url}/voiceflow/interaction`;
    const body = {
      user: attemptId,
      apiKey,
      payload
    };
    // @ts-ignore
    return this.http.post(url, body, { responseType });
  };

  public textToAudio = (lang: string, voice: string, transcript: string, payload = {}): Observable<any> => {
    const url = `${this.url}/voiceflow/text-to-audio`;
    const body = {
      lang,
      voice,
      transcript,
      payload
    };
    return this.http.post(url, body, { responseType: 'arraybuffer' });
  };
}
